import axios from "axios";
import { serviceBaseUrl } from "../constants/appConstants";

export const verifyTokenService = async () => {
  try {
    const response = await axios.post(
      `${serviceBaseUrl}/verifyToken`,
      {},
      {
        withCredentials: true, 
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return { success: true, data: response.data };
  } catch (error: unknown) {
    console.error('Error verifying token:', error);

    if (axios.isAxiosError(error)) {
      return { success: false, message: error.message };
    }

    return { success: false, message: 'An unknown error occurred' };
  }
};



export const logout = async (): Promise<number> => {
  const response = await axios.post(`${serviceBaseUrl}/logout`);
  return response.data.code;
};



